import { render, staticRenderFns } from "./OrderAttachments.vue?vue&type=template&id=5af1454d&scoped=true"
import script from "./OrderAttachments.vue?vue&type=script&lang=js"
export * from "./OrderAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1454d",
  null
  
)

export default component.exports